var React = require('react');

function JcdOnlyLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.027 0A5.027 5.027 0 0 0 0 5.027a5.027 5.027 0 0 0 .136 1.134 1.134 1.134 0 0 0 1.118-1.134V2.52h1.374v2.508A2.508 2.508 0 0 1 .645 7.478a5.027 5.027 0 0 0 4.382 2.576 5.027 5.027 0 0 0 4.795-3.52A2.508 2.508 0 0 1 7.82 7.536H6.447V5.027H7.82v1.134a1.134 1.134 0 0 0 1.134-1.134A1.134 1.134 0 0 0 7.82 3.893H6.447V2.519H7.82a2.508 2.508 0 0 1 1.994.992A5.027 5.027 0 0 0 5.027 0zm.698 2.52v1.373A1.134 1.134 0 0 0 4.59 5.027a1.134 1.134 0 0 0 1.135 1.134v1.374a2.508 2.508 0 0 1-2.508-2.508A2.508 2.508 0 0 1 5.725 2.52z","fill":"#f55"}));
}

JcdOnlyLogo.defaultProps = {"viewBox":"0 0 10.054 10.054","height":"38","width":"38"};

module.exports = JcdOnlyLogo;

JcdOnlyLogo.default = JcdOnlyLogo;
